export function EventDetailsSkeleton() {
  return (
    <dl className="flex flex-row items-center space-x-3">
      <div className="relative h-4 w-[110px]">
        <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-[#667085] to-transparent" />
      </div>
      <div className="relative h-4 w-[110px]">
        <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-[#667085] to-transparent" />
      </div>
      <div className="relative h-4 w-[110px]">
        <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-transparent via-[#667085] to-transparent" />
      </div>
    </dl>
  );
}
